import script from "./BaseFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFooter.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFooter.vue?vue&type=style&index=0&id=002a9054&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerk-am-see\\wp-content\\themes\\io.shop-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002a9054"]])

export default __exports__